import { AdaptiveModal } from '../AdaptiveModal';
import { AIChat } from './AIChat';

interface AIChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialConversationId?: string;
}

export function AIChatModal({ isOpen, onClose, initialConversationId }: AIChatModalProps) {
  return (
    <AdaptiveModal isOpen={isOpen} onClose={onClose} title="" size="xl">
      <div role="dialog" aria-modal="true" aria-label="AI Assistant" className="h-[75dvh] min-h-0">
        <AIChat onClose={onClose} initialConversationId={initialConversationId} />
      </div>
    </AdaptiveModal>
  );
}
